module.exports = __webpack_public_path__ + "static/img/josalukas.e40c0441.jpg";